module.exports = __webpack_public_path__ + "lp/img/up-icon-confirmation.bc405374.svg";